<span>{{'page.post_overview.post.post_type.label' | translate}}
    <ng-container *ngIf="postType === 'post'">{{'page.post_overview.post.post_type.post' | translate}}</ng-container>
    <ng-container *ngIf="postType === 'story'">{{'page.post_overview.post.post_type.story' | translate}}</ng-container>
    <ng-container *ngIf="postType === 'reel'">{{'page.post_overview.post.post_type.reel' | translate}}</ng-container>
</span>


// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-type-display/post-type-display.component.html